// extracted by mini-css-extract-plugin
export default {"container":"wq-z","heading":"xq-z","text":"yq-z","info":"zq-z","link":"Aq-z","fullMaxWidth":"Bq-z"};